var map = {
	"./de-DE/go-result.png": "8790",
	"./en-GB/go-result.png": "7f7b",
	"./en-US/go-result.png": "4809",
	"./es-ES/go-result.png": "bb4c",
	"./es-MX/go-result.png": "b4df",
	"./fr-CA/go-result.png": "9bb4",
	"./fr-FR/go-result.png": "2b49",
	"./it-IT/go-result.png": "cce1",
	"./ja-JP/go-result.png": "2ccd",
	"./pt-BR/go-result.png": "dd58",
	"./zh-TW/go-result.png": "3595"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5e8f";